module.exports = __webpack_public_path__ + "img/3.6e5db20c.jpeg";